import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchTestCaseRecords = async (id) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=searchTCRDropDown&companyid=${user.companyid}&tcid=${id}`,
  );

  return response.data;
};

const useSearchTestCaseRecordsQuery = (id, options) => {
  return useQuery({
    queryKey: ["ReportsTestCaseResults", id],
    queryFn: () => fetchTestCaseRecords(id),
    enabled: options.enabled,
    retry: true,
    cacheTime: 90000,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity
  });
};

export default useSearchTestCaseRecordsQuery;
